// 用户行为 0访问 1复制 2点击 3曝光
export const DEED_MAP = {
  VISITED: 0,
  COPY: 1,
  CLICK: 2,
  EXPOSURE: 3,
};
// 事件编号
export const OID_MAP = {
  PERFECT_USERINFO_JUMP_CLICK: 1338, // 个人中心2.0   完善信息弹窗-跳过本步骤点击
  PERFECT_USERINFO_EMAIL_BIND_SUCCESS: 1340, // 个人中心2.0   完善信息弹窗-成功绑定邮箱
  PERFECT_USERINFO_WECHAT_BIND_SUCCESS: 1341, // 个人中心2.0   完善信息弹窗-成功绑定微信
  SUBSCRIPTION_TEMPLATE_SUBSCRIBE_TO_RECOMMENDATIONS_EXPOSURE: 1211, //订阅模板-推荐订阅词的曝光[ctx:关键词推荐、历史甲方、竞争对手、竞争对手甲方]
  SUBSCRIPTION_TEMPLATE_SUBSCRIBE_TO_RECOMMENDATIONS_CLICK: 1212, //订阅模板-推荐订阅词的点击[1. 记录点击的方案类型btype 2. 记录点击的关键词ctx 3. 记录传入的关键词extendinfo]
  SUBSCRIPTION_TEMPLATE_CUSTOM_CREATE_BUTTON_CLICK: 1196, //订阅模板-自定义创建按钮点击
  SUBSCRIPTION_TEMPLATE_TEMPLATE_DETAILS_PAGE_EXPOSURE: 1194, //订阅模板-模板详情页曝光（ctx记录模板id）
  SUBSCRIPTION_TEMPLATE_MY_SUBSCRIPTION_EXPOSURE: 1195, //订阅模板-我的订阅曝光
  NOVICE_GUIDE_THE_ENTRANCE_BANNER_TO_SET_CLICK: 1213, //会员中心-新手引导入口横幅去设置按钮点击
  NOVICE_GUIDE_SKIP_BUTTON_CLICK: 1199, //订阅新手引导-跳过按钮点击（ctx记录步骤）
  NOVICE_GUIDE_POPUP_EXPOSURE: 1198, //订阅新手引导-  弹窗曝光（ctx记录步骤）
  NOVICE_GUIDE_UPPER_LIMIT_OF_QUANTITY_VERIFICATION_POPUP_EXPOSURE: 1200, //订阅新手引导-数量上限校验弹窗曝光
  NOVICE_GUIDE_RECOMMENDED_SUBSCRIPTION_MODULE_CLICK: 1208, //订阅新手引导-推荐订阅词模块点击【记录点击的方案类型】
  NOVICE_GUIDE_RECOMMENDED_SUBSCRIPTION_MODULE_EXPOSURE: 1207, //订阅新手引导-推荐订阅词模块曝光
  NOVICE_GUIDE_CLOSE_THE_CONFIRMATION_POPUP_ABANDON_BUTTON_CLICK: 1206, //订阅新手引导-关闭确认弹窗放弃按钮点击
  NOVICE_GUIDE_CLOSE_BUTTON_CLICK: 1205, //订阅新手引导-关闭按钮点击【ctx记录步骤】
  PERFECT_USERINFO_SAVING_CLICK: 1290, //完善信息弹窗保存按钮点击
  PERFECT_USERINFO_NEXT_STEP_CLICK: 1289, //完善信息弹窗下一步按钮点击
  PERFECT_USERINFO_POPUP_EXPOSURE: 1288, //完善信息弹窗曝光
  MORE_CONTACTS_EXPOSURE: 1372, // 更多联系人  弹窗曝光
  MORE_CONTACTS_TYPE_FILTER_CLICK: 1373, //更多联系人  手机座机筛选点击【extendinfo记录点击项名称】
  MORE_CONTACTS_SOURCE_OBJECT_TITLE_CLICK: 1374, //更多联系人  来源项目标题点击
  MORE_CONTACTS_SOURCE_OBJECT_EXPOSURE: 1375, //更多联系人  来源项目弹窗曝光
  MORE_CONTACTS_SOURCE_OBJECT_LIST_CLICK: 1376, //更多联系人  来源项目弹窗-列表点击
  MORE_CONTACTS_LINK_CLICK: 1377, //更多联系人  联系TA点击  更多联系人

  DAILY_ACCESS_LIMIT_DESCRIPTION_CLICK: 1371, // 浏览达上线提示弹窗-日访问额度说明点击
  BUY_NOW_BUTTON_CLICK: 1370, //   浏览达上线提示弹窗-立即购买按钮点击
  PURCHASE_QUOTA_PACKAGE_POINT_CLICK: 1369, // 浏览达上线提示弹窗-购买额度包点击
  QUOTA_CONFIGURATION_PAGE_CLICK: 1368, // 浏览达上线提示弹窗-额度配置页点击

  DIALOG_ENTERPRISE_BUY_EXPOSURE: 1394, //企业库2.0 购买信息弹框曝光
  DIALOG_ENTERPRISE_BUY_BUTTON_CLICK: 1395, //企业库2.0 点击立即开通
  DIALOG_SUB_ACCOUNT_BUY_EXPOSURE: 1392, //子账号购买信息弹框 曝光
  DIALOG_SUB_ACCOUNT_BUY_BUTTON_CLICK: 1393, //子账号购买信息弹框 点击立即开通

  DIALOG_REGIONAL_ADD_PURCHASES_BUY_BUTTON_CLICK: 1391, // 地区增购弹窗-立即开通按钮点击 详情页-2.0
  DIALOG_REGIONAL_ADD_PURCHASES_BUY_SHOW: 1390, //  地区增购弹窗触发 详情页-2.0

  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_EXPOSURE: 2045, //采购意向﹣详情页﹣开通会员弹窗曝光
  PURCHASE_INTENTION_FREE_TRIAL_EXPOSURE: 2046, //采购意向﹣详情页﹣领取体验特权弹窗﹣曝光
  PURCHASE_INTENTION_FREE_TRIAL_SUCCESS_EXPOSURE: 2047, //采购意向﹣详情页﹣领取体验特权弹窗﹣成功领取体验
  PURCHASE_INTENTION_FREE_TRIAL_IMMEDIATELY_BUY_CLICK: 2048, //采购意向﹣详情页﹣领取体验特权弹窗﹣点击立即购买
  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_IMMEDIATELY_BUY_CLICK: 2049, //采购意向﹣详情页﹣套餐选择弹窗﹣点击立即购买
  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_SUCCESS_EXPOSURE: 2050, //采购意向﹣详情页﹣支付成功，额外记录实付金额
};
